import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

interface PageTitleContextValue {
  title: string;
  setTitle: (value: string) => void;
}

const PageTitleContext = createContext<PageTitleContextValue | undefined>(
  undefined,
);

export function PageTitleProvider({
  children,
}: {
  children: React.ReactNode;
}): React.ReactElement {
  const [title, setTitleState] = useState<string>("");

  const setTitle = useCallback((value: string) => {
    setTitleState(value || "");
  }, []);

  const value = useMemo(() => ({ title, setTitle }), [title, setTitle]);
  return (
    <PageTitleContext.Provider value={value}>
      {children}
    </PageTitleContext.Provider>
  );
}

export function usePageTitle(): PageTitleContextValue {
  const ctx = useContext(PageTitleContext);
  if (!ctx)
    throw new Error("usePageTitle must be used within PageTitleProvider");
  return ctx;
}
